import { render, staticRenderFns } from "./MusicDatabaseTutorial.vue?vue&type=template&id=49e82e50&scoped=true&"
import script from "./MusicDatabaseTutorial.vue?vue&type=script&lang=js&"
export * from "./MusicDatabaseTutorial.vue?vue&type=script&lang=js&"
import style0 from "./MusicDatabaseTutorial.vue?vue&type=style&index=0&id=49e82e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e82e50",
  null
  
)

export default component.exports